import React from "react";
import { CreateRipple } from "./NextButton";

interface IFetchButtonProps {
  children: any;
  loader?: boolean;
  id?: string;
  icon?: string;
  handleClick?: () => void;
  className?: string;
  endIcon?: string;
  isAccessible?: any;
}

const FetchButton: React.FC<IFetchButtonProps> = ({
  children,
  id,
  icon,
  className,
  handleClick,
  loader,
  isAccessible = true,
}) => {
  return (
    isAccessible &&
    (loader ? (
      <div
        id={id}
        className={`primary-btn inactiveBtn`}
        onClickCapture={CreateRipple}
      >
        {icon ? (
          <div className="icon-wrapper fetching">
            <i className={icon}></i>
          </div>
        ) : null}
        <div className="label-wrapper">{children}</div>
      </div>
    ) : (
      <div
        id={id}
        className={`primary-btn ${className}`}
        onClick={handleClick}
        onClickCapture={CreateRipple}
      >
        {icon ? (
          <div className="icon-wrapper">
            <i className={icon}></i>
          </div>
        ) : null}
        <div className="label-wrapper">{children}</div>
      </div>
    ))
  );
};
export default FetchButton;
